/* eslint-disable default-case */

import has from 'lodash/has';
import get from 'lodash/get';

import { pageview, event, niEvent, GAAction } from '@analytics';
import { actions as Page } from '@pages/names';
import { isServer } from '@utils/browser';

const sendEventFromAction = (action, { getState }) => {
  if (action.type.indexOf('PAGE_') === 0) {
    return pageview(get(action, 'meta.location.current.pathname'));
  }

  switch (action.type) {
    case 'FORECAST_MATCHES_MATCH_SET': {
      const label = `Partido #${action.meta.mid}`;
      if (has(action.payload, 'teamHome') || has(action.payload, 'teamAway')) {
        return event(GAAction.EditTeam, { label });
      }
      return event(GAAction.EditScore, { label });
    }
    case 'FORECAST_GROUPS_GROUP_SET': {
      let pos = has(action.payload, 'firstTeam') ? '1' : '2';
      return event(GAAction.EditGroupWinner, {
        label: `Grupo ${action.meta.group} - ${pos}°`
      });
    }
    case 'PLAYERS_SELECTED_SET': {
      return event(GAAction.EditScorer, {
        label: action.payload
      });
    }
    case 'FORECAST_SAVING': {
      if (action.payload) {
        return event(GAAction.SaveForecast);
      }
      break;
    }
    case 'SUBPAGE_FORECAST': {
      return event(GAAction.ViewForecast);
    }
    case 'SUBPAGE_RESULTS': {
      return event(GAAction.ViewResults);
    }
    case 'USER_SAVING': {
      if (action.payload) {
        return event(GAAction.SaveUser);
      }
      break;
    }
    case 'CREATE_RANKING_VISIBLE': {
      if (get(getState(), 'location.type') === Page.RankingDetails) {
        return event(
          action.payload
            ? GAAction.OpenEditNameRanking
            : GAAction.CloseEditNameRanking
        );
      }

      return event(
        action.payload
          ? GAAction.OpenCreateRanking
          : GAAction.CloseCreateRanking
      );
    }
    case 'RANKINGS_ADD': {
      return event(GAAction.CreateRanking, {
        label: `Nombre: ${get(action, 'payload.name')}`
      });
    }
    case 'RANKING_PARTICIPANTS_VISIBLE': {
      return event(
        action.payload
          ? GAAction.OpenInviteRanking
          : GAAction.CloseInviteRanking
      );
    }
    case 'RANKING_DETAILS_REMOVED': {
      return event(GAAction.RemovedRanking);
    }
    case 'WELCOME_VISIBLE': {
      if (action.payload) return niEvent(GAAction.ShowWelcome);
      else return event(GAAction.HideWelcome);
    }
  }
};

const analytics = store => next => action => {
  if (!isServer) {
    try {
      sendEventFromAction(action, store);
    } catch (e) {
      console.error('Analytics GA Middleware - failed');
      console.error(e);
    }
  }

  return next(action);
};

export default analytics;
